( function () {

	function initTabs( wrapper ) {
		const tablist = wrapper.querySelector( '[role="tablist"]' );
		if ( ! tablist ) return;

		function getTabs()   { return Array.from( tablist.querySelectorAll( '[role="tab"]' ) ); }
		function getPanels() { return Array.from( wrapper.querySelectorAll( '[role="tabpanel"]' ) ); }

		function activateTab( tab ) {
			const tabs    = getTabs();
			const panels  = getPanels();
			const panelId = tab.getAttribute( 'aria-controls' );
			const target  = panelId ? wrapper.querySelector( '#' + panelId ) : null;

			tabs.forEach( ( t ) => {
				t.setAttribute( 'aria-selected', 'false' );
				t.setAttribute( 'tabindex', '-1' );
				t.classList.remove( 'is-active' );
			} );

			panels.forEach( ( p ) => {
				if ( p !== target ) {
					p.hidden = true;
				}
			} );

			tab.setAttribute( 'aria-selected', 'true' );
			tab.setAttribute( 'tabindex', '0' );
			tab.classList.add( 'is-active' );

			if ( target ) {
				target.hidden = false;
			}
		}

		tablist.addEventListener( 'click', function ( e ) {
			const tab = e.target.closest( '[role="tab"]' );
			if ( ! tab ) return;
			activateTab( tab );
			tab.focus();
		} );

		tablist.addEventListener( 'keydown', function ( e ) {
			const tabs = getTabs();
			const idx  = tabs.indexOf( document.activeElement );
			if ( idx === -1 ) return;

			let next = idx;
			if ( e.key === 'ArrowRight' ) {
				next = ( idx + 1 ) % tabs.length;
			} else if ( e.key === 'ArrowLeft' ) {
				next = ( idx - 1 + tabs.length ) % tabs.length;
			} else if ( e.key === 'Home' ) {
				next = 0;
			} else if ( e.key === 'End' ) {
				next = tabs.length - 1;
			} else {
				return;
			}

			e.preventDefault();
			tabs[ next ].focus();
			activateTab( tabs[ next ] );
		} );

		// Bootstrap: ensure active tab state matches PHP-rendered hidden attributes.
		const tabs          = getTabs();
		const panels        = getPanels();
		const activeTab     = tabs.find( ( t ) => t.getAttribute( 'aria-selected' ) === 'true' ) ?? tabs[ 0 ];
		const activePanelId = activeTab ? activeTab.getAttribute( 'aria-controls' ) : null;

		panels.forEach( ( p ) => {
			if ( p.id !== activePanelId ) {
				p.hidden = true;
			} else {
				p.hidden = false;
			}
		} );
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		document
			.querySelectorAll( '.wp-block-gandaki-govt-tabs-notice-grid' )
			.forEach( initTabs );
	} );

} )();
